import { RcClasses } from '../../../../foundation';
export var RcSplitButtonClasses = RcClasses([
    'root',
    'groupedHorizontal',
    'actionButton',
    'controlButton',
    'menuOpen',
    'groupedContainedHorizontal',
], 'RcSplitButton');
export var RcSplitButtonTouchRippleClasses = RcClasses(['child', 'ripplePulsate'], 'RcSplitButton-TouchRipple');
export var getVariant = function (variant) {
    switch (variant) {
        case 'round':
            return 'text';
        case 'plainIcon':
            return 'plain';
        default:
            return variant;
    }
};
export var variantIsHandler = function (variant) {
    return function (arr) { return arr.includes(variant); };
};
